import { render, staticRenderFns } from "./VatRateForm.vue?vue&type=template&id=8b5e2ada"
import script from "./VatRateForm.vue?vue&type=script&lang=js"
export * from "./VatRateForm.vue?vue&type=script&lang=js"
import style0 from "./VatRateForm.vue?vue&type=style&index=0&id=8b5e2ada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports